import {
  chatWithCursorAgent,
  resumeCursorAgentRun,
  type CursorAgentChatResult,
  type CursorAgentProgress,
  type CursorAgentProgressCallback,
} from './cursorAgentApi';
import { loadCursorAgentPreferences } from '../utils/cursorAgentPreferences';
import {
  clearPendingAgentRun,
  loadPendingAgentRun,
  savePendingAgentRun,
  type CursorAgentPendingRun,
} from '../utils/cursorAgentPendingRun';

export type { CursorAgentChatResult, CursorAgentProgress, CursorAgentProgressCallback };

const AGENT_ID_KEY = 'cursorAgent.agentId';

export function loadStoredCursorAgentId(): string | null {
  return localStorage.getItem(AGENT_ID_KEY);
}

export function saveStoredCursorAgentId(agentId: string | null): void {
  if (agentId) localStorage.setItem(AGENT_ID_KEY, agentId);
  else localStorage.removeItem(AGENT_ID_KEY);
}

export function markCursorAgentRunPending(agentId: string | null, runId?: string): void {
  if (!agentId?.trim()) return;
  const pending: CursorAgentPendingRun = { agentId: agentId.trim() };
  if (runId?.trim()) pending.runId = runId.trim();
  savePendingAgentRun(pending);
}

export function clearCursorAgentRunPending(): void {
  clearPendingAgentRun();
}

export function loadCursorAgentRunPending() {
  return loadPendingAgentRun();
}

export async function sendCursorAgentMessage(
  message: string,
  agentId: string | null,
  onProgress?: CursorAgentProgressCallback
): Promise<CursorAgentChatResult> {
  const { apiKey } = loadCursorAgentPreferences();
  return chatWithCursorAgent(apiKey, message, agentId, onProgress);
}

export async function resumeCursorAgentMessage(
  agentId: string,
  onProgress?: CursorAgentProgressCallback
): Promise<CursorAgentChatResult | null> {
  const { apiKey } = loadCursorAgentPreferences();
  return resumeCursorAgentRun(apiKey, agentId, onProgress);
}
